import { getConfig } from '../../configuration';
export default (message => {
  const appName = getConfig('appName');
  const version = getConfig('version');
  if (appName && version) {
    return `${appName} v${version} : ${message}`;
  }
  return message;
});